var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bl-backdrop-overlay" }, [
    _c(
      "div",
      {
        staticClass: "bl-backdrop",
        class: _vm.backdropClass,
        style:
          _vm.type === "error" || _vm.empty
            ? { width: "40rem" }
            : { width: _vm.maxWidth }
      },
      [
        _vm.title || _vm.description
          ? _c(
              "div",
              { staticClass: "bl-backdrop-header" },
              [
                _c(
                  "div",
                  { staticClass: "bl-backdrop-header-container" },
                  [
                    _vm.type === "error"
                      ? _c("BlIcon", {
                          staticClass: "bl-backdrop-header-icon",
                          attrs: { icon: "warning", color: "error" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.title
                      ? _c("BlTextTitle4", { attrs: { text: _vm.title } })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.description
                  ? _c("BlTextBody2", {
                      staticClass: "break-words flex-wrap",
                      class: { "lg:w-140": _vm.maxWidth === "unset" },
                      attrs: { text: _vm.description }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.empty
          ? _c(
              "div",
              { staticClass: "bl-backdrop-body" },
              [_vm._t("default")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.footer
          ? _c(
              "div",
              { staticClass: "bl-backdrop-footer" },
              [
                _c("BlInputButton", {
                  staticClass: "bl-backdrop-action",
                  attrs: { label: _vm.cancelLabel, type: "plain" },
                  on: {
                    clicked: function($event) {
                      return _vm.$emit("backdrop-close")
                    }
                  }
                }),
                _vm._v(" "),
                _vm.label
                  ? _c("BlInputButton", {
                      staticClass: "bl-backdrop-action lg:max-w-64",
                      attrs: {
                        label: _vm.label,
                        type: _vm.type === "error" ? "error" : "",
                        disabled: _vm.disabled,
                        loading: _vm.submitLoading
                      },
                      on: {
                        clicked: function($event) {
                          return _vm.$emit("backdrop-action")
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-edf2ae20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edf2ae20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlBackdrop.vue
// module id = null
// module chunks = 